export const Stats = ({ stats }) => {
  return (
    <div className="items-center justify-center w-full gap-5 py-20 mx-auto mt-5 align-bottom bg-bgcard md:flex xl:mt-16 md:py-32">
      <ul className="container mx-auto md:flex">
        {stats.map((item, index) => (
          <li key={index} className="flex items-center md:flex-1 md:flex-col">
            {item.icon[0].url && (
              <img
                src={item.icon[0].url}
                referrerPolicy="no-referrer"
                alt={item.icon[0].altTag || ""}
                className="w-16 h-full mt-8 ml-12 md:ml-0 md:mt-0 md:w-24"
              />
            )}
            
            <div className="ml-5 md:ml-0 md:text-center">
              <h1 className="mt-10 text-3xl font-bold md:text-5xl text-secondary">
                {item.amount}
              </h1>
              <p className="mt-2 text-lg text-center align-text-bottom text-secondary xl:text-xl 2xl:text-2xl md:text-base">
                {item.description}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}